import { render, staticRenderFns } from "./fccOrgaoExpedidor.vue?vue&type=template&id=464a4ec5"
import script from "./fccOrgaoExpedidor.vue?vue&type=script&lang=js"
export * from "./fccOrgaoExpedidor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports